import * as React from "react"

import { BrokerChoiceCard } from "@/components/Broker/BrokerChoiceCard"
import { cn } from "@/lib/utils"
import { isCustomCsvBrokerName } from "@/utils/customCsvAccountDisplay"

const TITLE_CLASS =
  "font-[family-name:var(--font-primary)] text-base font-normal text-[color:var(--brand-tropical-surf)]"

const DESC_CLASS =
  "font-[family-name:var(--font-primary)] text-sm font-normal leading-5 text-gray-500 dark:text-white"

export type ConnectBrokerSelectedBrokerHeadingProps = {
  brokerName: string
  displayName: string
  title: string
  description?: string
  /** Use demo page-title sizing (forced via CSS on data-demo-wizard-title). */
  titleAsPageHeading?: boolean
  /** Hide the selected broker tile (e.g. custom CSV — no redundant “broker not listed” card). */
  showBrokerTile?: boolean
  className?: string
}

/**
 * Selected broker tile (same chrome as the choose-step grid) left of the step title + copy.
 */
export function ConnectBrokerSelectedBrokerHeading({
  brokerName,
  displayName,
  title,
  description,
  titleAsPageHeading = false,
  showBrokerTile = true,
  className,
}: ConnectBrokerSelectedBrokerHeadingProps): React.ReactElement {
  const isOther = isCustomCsvBrokerName(brokerName)

  return (
    <div
      data-connect-broker-selected-heading=""
      className={cn("flex w-full min-w-0 items-start gap-4", className)}
    >
      {showBrokerTile ? (
        <div className="w-[7.25rem] shrink-0 sm:w-[8.5rem]">
          <BrokerChoiceCard
            brokerName={brokerName}
            displayName={displayName}
            selected
            variant={isOther ? "other" : "logo"}
            interactive={false}
          />
        </div>
      ) : null}
      <div className="flex min-w-0 flex-1 flex-col gap-1.5 pt-0.5 sm:pt-1">
        {titleAsPageHeading ? (
          <h1 data-demo-wizard-title="" className={TITLE_CLASS}>
            {title}
          </h1>
        ) : (
          <h2 className={TITLE_CLASS}>{title}</h2>
        )}
        {description ? <p className={DESC_CLASS}>{description}</p> : null}
      </div>
    </div>
  )
}
